import { Button, Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import { Transition } from '@headlessui/react';
import { Fragment } from 'react';

interface FinishChartProps {
	show: boolean;
	setShow: (value: boolean) => void;
	close?: () => void;
}

export const FinishChartModal: React.FC<FinishChartProps> = ({
	show,
	setShow,
	close,
}) => {
	return (
		<Transition appear show={show} as={Fragment}>
			<div>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0"
					enterTo="opacity-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100"
					leaveTo="opacity-0"
				>
					<div
						className="absolute inset-0 z-20 rounded-2xl"
						style={{
							backdropFilter: 'blur(2px)',
							background: '#0000003D',
						}}
					/>
				</Transition.Child>
				<Transition.Child
					as={Fragment}
					enter="ease-out duration-300"
					enterFrom="opacity-0 scale-95"
					enterTo="opacity-100 scale-100"
					leave="ease-in duration-200"
					leaveFrom="opacity-100 scale-100"
					leaveTo="opacity-0 scale-95"
				>
					<div className="absolute top-[35%] left-0 overflow-y-auto z-30 bg-white rounded-2xl px-8 py-4 mx-4">
						<div className="flex justify-center w-full items-center gap-x-2">
							<Icon
								src={Icons.rafiki}
								className="!w-6 !h-8"
								width={24}
								height={32}
							/>
							<Typography type="semibold-16" className="text-black">
								Close this conversation?
							</Typography>
						</div>
						<Typography
							type="regular-14"
							className="text-opacity-black text-center mt-4"
						>
							Don’t worry, you can start a new one whenever you want!
						</Typography>
						<div className="flex justify-center items-center w-full gap-x-2 mt-4">
							<Button
								size="fit"
								label="Cancel"
								decoration="secondary"
								className="!py-1"
								onClick={() => setShow(false)}
							/>
							<Button
								size="fit"
								label="End Chat"
								decoration="primary"
								className="!py-1"
								onClick={() => {
									close && close();
									setShow(false);
								}}
							/>
						</div>
					</div>
				</Transition.Child>
			</div>
		</Transition>
	);
};
